import { Link } from 'react-router-dom';

interface ArticleContentProps {
  title: string;
  categoryName: string;
  category: string;
  date: string;
  author: string;
  readTime: string;
  imageUrl: string;
  contentHtml: string;
}

export default function ArticleContent({
  title,
  categoryName,
  category,
  date,
  author,
  readTime,
  imageUrl,
  contentHtml,
}: ArticleContentProps) {
  return (
    <article className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
      <div className="relative h-52 md:h-72 overflow-hidden">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="p-6 md:p-8">
        <div className="flex items-center gap-3 mb-4 flex-wrap">
          <Link
            to={`/category/${category}`}
            className="text-xs text-accent-600 font-medium bg-accent-100 px-3 py-1 rounded-full hover:bg-accent-200 transition-colors cursor-pointer"
          >
            {categoryName}
          </Link>
          <span className="text-xs text-foreground-400">
            <i className="ri-calendar-line mr-1"></i>
            {date}
          </span>
          <span className="text-xs text-foreground-400">
            <i className="ri-user-line mr-1"></i>
            {author}
          </span>
          <span className="text-xs text-foreground-400">
            <i className="ri-time-line mr-1"></i>
            阅读 {readTime}
          </span>
        </div>

        <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 leading-snug mb-6">
          {title}
        </h1>

        <div
          className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed"
          dangerouslySetInnerHTML={{ __html: contentHtml }}
        />
      </div>
    </article>
  );
}